"use client";

import { ArrowRight, Zap, Layers3 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function UpgradeYourLimit() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="upgrade-your-limit" className="bg-background text-foreground py-16 px-4 sm:px-6 lg:px-8">
      <div ref={ref} className={cn("max-w-4xl mx-auto border border-border bg-card/40 rounded-3xl p-8 sm:p-12 md:p-16 text-center transition-all duration-700 ease-out shadow-[0_18px_40px_-24px_rgba(0,0,0,0.16)]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="mb-5 inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
          <Layers3 className="size-4" />
          Capacity options
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight mb-6">
          Upgrade your limit without losing control
        </h2>

        <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto mb-10">
          Add Capacity Packs to your current tier or move to a higher subscription plan when your
          RAG deployment needs more room to grow.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="w-full sm:w-auto gap-2">
            <Link to="/CapacityPacksPage">
              <Zap className="size-4" />
              Add Capacity
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto gap-2">
            <Link to="/PricingPage">
              Upgrade Plan
              <ArrowRight className="size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}